<template>
  <teleport to="body">
    <transition name="modal-fade">
      <div
        v-if="isOpen"
        class="search-modal-overlay"
        @click="closeOnOverlay"
      >
        <div class="search-modal-container" @click.stop>
          <div class="search-modal-header">
            <h2 class="search-modal-title">
              <i class="bi bi-search"></i>
              CRM durchsuchen
            </h2>
            <button
              type="button"
              class="btn-close"
              aria-label="Schließen"
              @click="close"
            ></button>
          </div>

          <div class="search-modal-body">
            <ContactSearch ref="searchComponent" :is-modal="true" />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import ContactSearch from './ContactSearch.vue'

export default {
  name: 'SearchModal',
  components: {
    ContactSearch,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  mounted() {
    // Listen for custom event to open modal
    document.addEventListener('open-search-modal', this.open)

    // Listen for ESC key
    document.addEventListener('keydown', this.handleEscape)
  },
  beforeUnmount() {
    document.removeEventListener('open-search-modal', this.open)
    document.removeEventListener('keydown', this.handleEscape)
  },
  methods: {
    open() {
      this.isOpen = true
      document.body.style.overflow = 'hidden'

      // Focus search input after modal opens
      this.$nextTick(() => {
        const searchInput = this.$refs.searchComponent?.$el.querySelector('input[type="text"]')
        if (searchInput) {
          searchInput.focus()
        }
      })
    },
    close() {
      this.isOpen = false
      document.body.style.overflow = ''
    },
    closeOnOverlay(event) {
      // Close only if clicking directly on overlay, not on modal content
      if (event.target === event.currentTarget) {
        this.close()
      }
    },
    handleEscape(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close()
      }
    },
  },
}
</script>
